<div class="widget-content">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <h2 class="title">Upcoming Teams</h2>
    <item-picker
      [data]="itemPickerValues"
      [selectedValue]="selectedItemPickerValue"
      (select)="itemPickerSelect($event)"
    ></item-picker>
  </div>
  <div *ngIf="loaded">
    <div *ngIf="odataResult.length > 0">
      <div class="bars-container">
        <app-upcoming-teams-bar-chart *ngFor="let item of odataResult" [item]="item"></app-upcoming-teams-bar-chart>
      </div>
      <a mat-button class="view-all" (click)="goToUpcomingTeams()">VIEW ALL UPCOMING TEAMS</a>
    </div>
    <div class="no-teams-content" fxLayout="column" fxLayoutAlign="center center" *ngIf="odataResult.length == 0">
      <p>You have no upcoming teams</p>
      <button *ngIf="isManager()" mat-raised-button color="primary" (click)="addTeam.emit()">CREATE A NEW TEAM</button>
      <a mat-button class="view-all" (click)="goToTeams()">VIEW ALL ACTIVE TEAMS</a>
    </div>
  </div>
  <div *ngIf="!loaded" class="waiting-spinner">
    <mat-spinner strokeWidth="2" diameter="50"></mat-spinner>
    <p>Loading...</p>
  </div>
</div>
